module.exports = __webpack_public_path__ + "img/15.7e5aea27.jpg";